import ActivityKPI from './ActivityKPI';

export default ActivityKPI;
